module.exports = __webpack_public_path__ + "img/logo.c17d2c83.png";